module.exports = __webpack_public_path__ + "static/hero-9a98b69a1e11503111cb11f4ba89eee0.gif";